import React from "react";
import get from "lodash/get";
import toLower from "lodash/toLower";
import LearnMoreModal from "../../../parts/modals/learn-more";
import BuildProgramStepOneModal from "../../../parts/modals/add-cycle";
import SortCategoriesModal from "../../../parts/modals/sort-categories";
import ManageCategoriesModal from "../../../parts/modals/manage-categories";
import EditProgramSettingsModal from "../../../parts/modals/edit-program-settings";
import Store from "./Store";
import SendModal from "../common-components/SendModal";
import FetchModal from "../common-components/FetchModal";
import TestPushAccountModal from "./components/TestPushAccountModal";
import { getPushTestEmail } from "../../../utils/user-helpers";
import { fetchSendProjection } from "../../../utils/projection-helpers";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

const StoreController = async ({ res, req, locals, load }) => {
  const { query = {} } = req;
  const coachOrganizationPermissions =
    locals?.activeUser?.organizationPermissions || [];
  // First look for the permissions that allow the coach to acces to the store -
  // - in the ORGANIZATION permissions
  // These are by now "Templates" and "PUSH"
  const organizationStorePermissions =
    locals?.organizationPermissions?.filter((permission) =>
      ["PUSH"].includes(permission.permission)
    ) || {};

  // Then, in the permisisons of the COACH, find the a permissions that matches with the ones that
  // allow the coach to access to the store
  if (
    locals?.activeUser?.organizationUserStatus &&
    !organizationStorePermissions.some((storePermission) =>
      coachOrganizationPermissions.includes(storePermission._id)
    )
  )
    return res.redirect("/coaching-portal/athletes");
  const proxyAthlete = query.athlete;
  if (query.menuExpanded) res.refreshWith({ menuExpanded: false });
  const loadPromises = [load("storePrograms")];
  const modal = get(query, "modal", {});

  const queryEditCycleSettings = {
    cycle: query.cycleId,
    proxyAthlete,
  };

  //The user is allow to see al the athletes of the coaches
  const isAllowToViewAllOrganizationsAthletes =
    locals.organizationRoleName &&
    (locals.organizationRoleName === "Owner" ||
      locals.organizationRoleName === "Admin");

  switch (modal.type) {
    case "edit-cycle-settings":
    case "edit-program-settings":
      loadPromises.push(load("editCycle", queryEditCycleSettings));
      break;
    case "learn-more":
      loadPromises.push(
        load("editCycle", { cycle: query.cycleId }),
        load("programExercises", { programId: query.cycleId })
      );
      break;
    case "send":
      loadPromises.push(
        load("athleteCycles", { customProjection: fetchSendProjection })
      );
      if (query.recipient)
        loadPromises.push(load("unPushedAthleteCyclesNames", query.recipient));
      break;
    case "fetch":
      loadPromises.push(
        load("allAthletesFromOrganization"),
        load("copiableCycles", {})
      );
      break;
    default:
      break;
  }

  if (locals.activeUserToRequest && locals.activeUserToRequest.email) {
    const testEmail = getPushTestEmail(locals.activeUserToRequest.email);
    loadPromises.push(load("userByEmail", { email: toLower(testEmail) }));
  }

  await Promise.all(loadPromises);

  const { storePrograms, activeUserToRequest } = locals;

  const {
    pushAccountInfo: {
      mostPopular = null,
      programCategories = [],
      mostPopularSingle,
    } = {},
  } = activeUserToRequest;

  const refresh = (selectedCategoryIndex = "", category = "") => {
    res.refreshWith(
      {
        selectedCategoryIndex,
        category,
        newCategory: "",
        deleteIndex: "",
        update: "",
        favorite: "",
      },
      { url: "/coaching-portal/store", hash: "#_" }
    );
  };

  const isNewCategory = Boolean(query.newCategory && !query.modal);
  const isDeletingCategory = Boolean(
    query.deleteIndex && typeof query.deleteIndex === "number"
  );
  const isSelectAll = Boolean(
    query.selectedCategoryIndex && query.selectedCategoryIndex === "all"
  );
  const isFavorite = Boolean(query.favorite);
  const isAnUpdate = Boolean(query.update);

  if (isAnUpdate) refresh(query.selectedCategoryIndex, query.category);

  if (isNewCategory || isDeletingCategory || isSelectAll || isFavorite)
    refresh();

  locals.modal = {
    "build-step-one": <BuildProgramStepOneModal />,
    "edit-cycle-settings": <BuildProgramStepOneModal />,
    "edit-program-settings": <EditProgramSettingsModal />,
    "learn-more": <LearnMoreModal />,
    "manage-categories": (
      <ManageCategoriesModal
        category={query.category}
        selectedCategoryIndex={query.selectedCategoryIndex}
        programs={storePrograms[query.status || "published"]}
        //restOfPrograms is to edit a category in both published and draft programs
        restOfPrograms={
          storePrograms[query.status === "draft" ? "published" : "draft"]
        }
        newCategory={query.newCategory || false}
        onSave={() => {}}
        storeType={query.storeType || "programs"}
      />
    ),
    "sort-categories": (
      <SortCategoriesModal
        activeUserToRequest={locals.activeUserToRequest}
        categories={programCategories || []}
        onSave={() => {}}
      />
    ),
    fetch: (
      <FetchModal
        subscription
        isAllowToViewAllOrganizationsAthletes={
          isAllowToViewAllOrganizationsAthletes
        }
      />
    ),
    send: <SendModal />,
    "test-account": <TestPushAccountModal />,
    "activity-feed": <ActivityDrawer />,
  }[modal.type];

  query.sort = query.sort || "modifiedDate";

  res.body = (
    <Store
      total={20}
      query={query}
      mostPopular={mostPopular}
      programCategories={programCategories}
      mostPopularSingle={mostPopularSingle}
    />
  );
};

export default StoreController;
